(function (global, factory) {
  if (typeof define === "function" && define.amd) {
    define(["exports", "@babel/runtime/helpers/objectWithoutProperties", "@babel/runtime/helpers/extends", "react", "antd/lib/table", "antd/lib/pagination", "../index"], factory);
  } else if (typeof exports !== "undefined") {
    factory(exports, require("@babel/runtime/helpers/objectWithoutProperties"), require("@babel/runtime/helpers/extends"), require("react"), require("antd/lib/table"), require("antd/lib/pagination"), require("../index"));
  } else {
    var mod = {
      exports: {}
    };
    factory(mod.exports, global.objectWithoutProperties, global._extends, global.react, global.table, global.pagination, global.index);
    global.unknown = mod.exports;
  }
})(this, function (_exports, _objectWithoutProperties2, _extends2, _react, _table, _pagination, _index) {
  "use strict";

  var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

  Object.defineProperty(_exports, "__esModule", {
    value: true
  });
  Object.defineProperty(_exports, "default", {
    enumerable: true,
    get: function get() {
      return _index.DataGrid;
    }
  });
  Object.defineProperty(_exports, "Filter", {
    enumerable: true,
    get: function get() {
      return _index.Filter;
    }
  });
  Object.defineProperty(_exports, "Any", {
    enumerable: true,
    get: function get() {
      return _index.Any;
    }
  });
  _exports.Pagination = _exports.Table = void 0;
  _objectWithoutProperties2 = _interopRequireDefault(_objectWithoutProperties2);
  _extends2 = _interopRequireDefault(_extends2);
  _react = _interopRequireDefault(_react);
  _table = _interopRequireDefault(_table);
  _pagination = _interopRequireDefault(_pagination);
  var antd = {
    Table: _table.default,
    Pagination: _pagination.default
  };
  var component = {
    Table: function Table(props) {
      var ListTable = (0, _index.TableWrapper)(_table.default);
      return _react.default.createElement(ListTable, (0, _extends2.default)({}, props, {
        pagination: false
      }));
    },
    Pagination: function Pagination(props) {
      // 由于antd和nolist的参数基本一致(currentPage, pageSize, total) 因此这里只展示有差异的
      var HOCPagination = function HOCPagination(hocProps) {
        var currentPage = hocProps.currentPage,
            others = (0, _objectWithoutProperties2.default)(hocProps, ["currentPage"]);
        return _react.default.createElement(_pagination.default, (0, _extends2.default)({
          current: currentPage
        }, others));
      };

      var ListPagination = (0, _index.PaginationWrapper)(HOCPagination);
      return _react.default.createElement(ListPagination, props);
    }
  };
  Object.keys(component).forEach(function (key) {
    var antdComponent = antd[key];
    Object.keys(antdComponent).forEach(function (attr) {
      component[key][attr] = antdComponent[attr];
    });
  });
  var Table = component.Table,
      Pagination = component.Pagination;
  _exports.Pagination = Pagination;
  _exports.Table = Table;
});